import React from 'react';
import '../static/css/VerifyEmail.css';
import logo from '../static/images/images/a-logo-transperent.png';

function NotFound() {
    return (
        <div className="verify-email-container">
            <div className="animates-logo-container"><img className="animates-logo" src={logo} alt="AniMates Logo" /></div>
            <div className="verify-email-content">
                <p className="verify-email-message" style={{ fontSize: '48px', color: '#85C7DD' }}>404</p>
                <p className="verify-email-message">Page not found</p>
                <p className="verify-email-submessage">The page you're looking for doesn't exist or has been moved.</p>
                <a href="/" className="verify-email-button">Exit</a>
            </div>
            <p className="verify-email-footer">© 2026 AniMates. All rights reserved.</p>
        </div>
    );
}

export default NotFound;
